export const SET_PROFILE = 'SET_PROFILE';

export const setProfile = payload => ({
  type: SET_PROFILE,
  payload
});
